import { classnames } from '@aibees/shared/utils';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RenderFieldsProps as Props } from './types';
import { FieldType, WhiteLabelField } from '../../types';

export const RenderFields = memo(({ className, children }: Props) => {
  const {
    companyDomain,
    companyName,
    primaryColor,
    notifBg,
    headerLogo,
    loginLogo,
    favicon,
    loaderLogo,
    handleChangeCompanyDomain,
    handleChangeCompanyName,
    handleChangePrimary,
    handleChangeNotifBg,
    handleChangeHeaderLogo,
    handleChangeLoginLogo,
    handleChangeFavicon,
    handleChangeLoaderLogo,
  } = useWhiteLabelContext();

  const feildItems: WhiteLabelField[] = [
    {
      label: 'Company Domain',
      onChange: handleChangeCompanyDomain,
      value: companyDomain.value,
      error: companyDomain.error,
      errorMessage: companyDomain.errorMessage,
      fieldType: FieldType.TEXT,
    },
    {
      label: 'Company Name',
      onChange: handleChangeCompanyName,
      value: companyName.value,
      error: companyName.error,
      errorMessage: companyName.errorMessage,
      fieldType: FieldType.TEXT,
    },
    {
      label: 'Primary Color',
      onChange: handleChangePrimary,
      value: primaryColor.value,
      color: primaryColor.value,
      error: primaryColor.error,
      errorMessage: primaryColor.errorMessage,
      fieldType: FieldType.TEXT,
    },
    {
      label: 'Login Background Color',
      onChange: handleChangeNotifBg,
      value: notifBg.value,
      color: notifBg.value,
      error: notifBg.error,
      errorMessage: notifBg.errorMessage,
      fieldType: FieldType.TEXT,
    },
    {
      label: 'Header logo image',
      endIcon: 'photo-up',
      startIcon: 'photo-outline',
      fieldType: FieldType.FILE,
      onChangeFile: handleChangeHeaderLogo,
      file: headerLogo.value,
      error: headerLogo.error,
      errorMessage: headerLogo.errorMessage,
    },
    {
      label: 'Logo for login page',
      endIcon: 'photo-up',
      startIcon: 'photo-outline',
      fieldType: FieldType.FILE,
      onChangeFile: handleChangeLoginLogo,
      file: loginLogo.value,
      error: loginLogo.error,
      errorMessage: loginLogo.errorMessage,
    },
    {
      label: 'Favicon',
      endIcon: 'photo-up',
      startIcon: 'photo-outline',
      fieldType: FieldType.FILE,
      onChangeFile: handleChangeFavicon,
      file: favicon.value,
      error: favicon.error,
      errorMessage: favicon.errorMessage,
    },
    {
      label: 'Logo for loader',
      endIcon: 'photo-up',
      startIcon: 'photo-outline',
      fieldType: FieldType.FILE,
      onChangeFile: handleChangeLoaderLogo,
      file: loaderLogo.value,
      error: loaderLogo.error,
      errorMessage: loaderLogo.errorMessage,
    },
  ];
  return (
    <Styled.Wrapper
      className={classnames('RenderFields', className)}
      sx={SX.root}
    >
      {children(feildItems)}
    </Styled.Wrapper>
  );
});

RenderFields.displayName = 'RenderFields';
